import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json } from '../../../../utils/ajax'
import { isAuthenticated } from '../../../../utils/Session'

class easyReportContentStore {

    @observable directory
    @observable contents
    @observable loading
    @observable options
    @observable selectType //ture快讯
    @observable list
    @observable pagination
    @observable catalogId //选择简报
    @observable carId //选择的车系
    @observable search //查询参数
    @observable modal
    @observable forms
    @observable contentId
    @observable initModal
    @observable carName
    @observable carseries

    constructor () {
        this.initStore()
    }

    @action initStore = () => {
        this.options = []
        this.directory = []
        this.contents = []
        this.carseries = []
        this.loading = false
        this.selectType = true
        this.pagination = {
            current: 1,
            total: 10,
        }
        this.search = {}
        this.list = []
        this.catalogId = ""
        this.modal = 'noShow'
        this.forms = {}
        this.initModal = true
        this.carId = ""
    }

    //Tree
    @action
    initDirectory = async (id) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/catalog/list?carseriesId=${id}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.directory = res
            this.loading = false
        })
    }

    @action emptySelect = () => {
        runInAction(() => {
                this.brands = {
                    list: [],
                    selected: ''
                }
                this.carSeries = {
                    list: [],
                    selected: ''
                }
            }
        )
    }
    @action empetyDirectory = () => {
        runInAction(() => {
            this.directory = []
            this.list = []
        })
    }

    @action empetyForms = () => {
        runInAction(() => {
                this.forms = {}
                if (!this.initModal && window.tinymce.activeEditor) {
                    window.tinymce.activeEditor.setContent('')
                }
            }
        )
    }

    @action empetyContents = () => {
        runInAction(() => {
                this.contents = []
            }
        )
    }

    @action setFormsContents = (content) => {
        runInAction(() => {
                this.forms.content = content
            }
        )
    }

    @action changeSelectType = (boolean) => {
        runInAction(() => {
                this.selectType = boolean
            }
        )
    }

    @action changerList=()=>{
        runInAction(() => {
            this.list=[]
        })
    }

    @action changeCarId = (id) => {
        runInAction(() => {
                this.carId = id
                this.catalogId = ""
            }
        )
    }

    @action
    initSearchField (values) {
        runInAction(() => {
                this.search = values
                this.catalogId = values.catalogId
            }
        )
    }

    @action
    onSearchFieldChange (values) {
        runInAction(() => {
                this.search.title = values.title
            }
        )
    }

    @action initList = async (page) => {
        runInAction(() => {
            this.loading = true
        })

        if (page) {
            page--
        } else if (this.pagination.current) {
            page = (this.pagination.current - 1).toString()
        } else {
            page = '0'
        }
        // 构建查询参数
        let search = {}
        Object.keys(this.search).forEach(key => {
            search[`search.${key}`] = this.search[key] ? this.search[key] : ''
        })
        search.page = page
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontents`, search)
        runInAction(() => {
            this.pagination = {
                total: res.totalElements,
                results: res.size,
                page: res.number + 1,
            }
            this.list = res.content
            this.loading = false
        })
    }

    @action delete = async (id) => {
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent:delete?id=${id}`)
        if (res && res.status >= 400) {
            return
        } else {
            if (this.list.length === 1) {
                await this.initList(this.pagination.page - 1)
            } else {
                await this.initList(this.pagination.page)
            }

        }
        message.success('删除成功')
    }

    @action save = async (key) => {
        runInAction(() => {
            this.forms.carName = this.carName
            this.forms.carSeriesId = this.carId
            this.forms.catalogId = this.catalogId ? this.catalogId : '0'
            this.forms.type = this.selectType ? '1' : '0'
            key === '1' ? this.forms.approval = '1' : this.forms.approval = '3'
            this.loading = true
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/add/jbcontent`, {
            ...this.forms
        })
        if (res && res.status >= 400) {
            message.error('新增失败')
            return
        } else {
            await this.initList()
            runInAction(() => {
                this.modal = 'hide'
                key === '1' ? message.success('保存草稿成功') : message.success('送审成功')
                this.forms = {}
                this.loading = false
            })
        }

    }

    @action update = async (key) => {
        runInAction(() => {
            this.forms.carSeriesId = this.carId
            this.forms.catalogId = this.catalogId
            key === '1' ? this.forms.approval = '1' : this.forms.approval = '3'
            this.loading = true
        })
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent:update`, {
            ...this.forms
        })
        if (res && res.status >= 400) {
            message.error('修改失败')
            return
        } else {
            await this.initList(this.pagination.page)
            runInAction(() => {
                this.modal = 'hide'
                message.success('修改成功')
                this.contentId = ''
                this.forms = {}
                this.loading = false
            })
        }

    }

    @action refreshPage = () => {
        runInAction(() => {
            this.pagination = {
                current: 1,
                total: 10,
            }
            this.search = {}
        })
    }

    @action showModal = (flag, id) => {
        runInAction(() => {
            this.loading = true
            this.modal = flag ? 'show' : 'hide'
            flag || window.tinymce.activeEditor.setContent('')
            this.contentId = id
            this.loading = false
        })
    }

    /**
     *
     * 平行化表单，传值给form
     */
    @computed
    get fields () {
        let fields = {
            id: {value: this.forms.id},
            carseriesId: {value: this.forms.carseriesId},
            catalogId: {value: this.forms.catalogId},
            catalogName: {value: this.forms.catalogName},
            introduction: {value: this.forms.introduction},
            number: {value: this.forms.number},
            pImage: {value: this.forms.pImage},
            title: {value: this.forms.title},
            type: {value: this.forms.type},
            approval: {value: this.forms.approval},
            content: {value: this.forms.content},
            cImage: {value: this.forms.cImage},
            carName: {value: this.forms.carName}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     *
     */
    @action.bound
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            carseriesId: fields.carseriesId.value,
            catalogId: fields.catalogId.value,
            catalogName: fields.catalogName.value,
            introduction: fields.introduction.value,
            number: fields.number.value,
            pImage: fields.pImage.value,
            title: fields.title.value,
            type: fields.type.value,
            approval: fields.approval.value,
            content: fields.content.value,
            cImage: fields.cImage.value,
            carName: fields.carName.value
        }

        this.forms = forms
    }

    @action initForms = async () => {
        runInAction(() => {
            this.forms = {}
            this.loading = true
        })
        if (this.contentId) {
            let id = this.contentId
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/jbcontent?id=${id}`)
            if (res && res.status === 0) {
                return
            }
            runInAction(() => {
                this.forms = res
            })
        }
        if (!this.initModal && window.tinymce.activeEditor) {
            let content = this.forms.content ? this.forms.content : ''
            window.tinymce.activeEditor.setContent(content)
        }
        runInAction(() => {
            this.loading = false
            this.initModal = false
        })
    }

    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }

    /**
     * 初始化车系
     */
    @action initCarseries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.carseries = res
            this.loading = false
        })
    }

    /**
     * 拿到车系名称
     */
    @action singleCarSeries = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/jsjb/carseriesCatalog/carseries/id/${this.carId}`)
        if(res && res.status === 0){
            return
        }
        runInAction(() => {
            this.loading = false
            this.carName = res.carseriesName
        })
    }
}
export default new easyReportContentStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/Briefing/BriefingContent/store.js